import * as React from 'react';

export default class BackIcon extends React.PureComponent<{}> {

    public render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                <path d="M8.44531 1.10938L1.55531 7.99937L8.44531 14.8894" stroke="#838383" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }
}
